import { createSvgIcon } from '@mui/material/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ReferralUserIcon = createSvgIcon( /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx("path", {
    d: "M18,7.93V9a1,1,0,0,1-2,0V7.93a1.14,1.14,0,0,0-1.14-1.15H13.77V8.11a.51.51,0,0,1-.86.36L10.59,6.16a.5.5,0,0,1,0-.71l2.31-2.3a.5.5,0,0,1,.86.36V4.78h1.09A3.15,3.15,0,0,1,18,7.93Z"
  }), /*#__PURE__*/_jsx("circle", {
    cx: "7.47",
    cy: "8.05",
    r: "2.27"
  }), /*#__PURE__*/_jsx("path", {
    d: "M7.5,11.46A4.53,4.53,0,0,0,3,15.35a.57.57,0,0,0,.56.65h7.86a.57.57,0,0,0,.56-.65A4.53,4.53,0,0,0,7.5,11.46Z"
  }), /*#__PURE__*/_jsx("circle", {
    cx: "16.47",
    cy: "13.06",
    r: "2.27"
  }), /*#__PURE__*/_jsx("path", {
    d: "M16.5,16.46A4.53,4.53,0,0,0,12,20.35a.57.57,0,0,0,.56.65h7.86a.57.57,0,0,0,.56-.65A4.53,4.53,0,0,0,16.5,16.46Z"
  })]
}), 'ReferralUserIcon');